// Context: docs/components/tile-mediatype-icon.md (which tiles get which indicator)

export type TileMediaIcon = "audio" | "video" | null;

const AUDIO_TYPES = ["audio", "audio_stream", "short_form_audio"];
const VIDEO_TYPES = ["video", "short_form_video"];

// Indicator for the top-left tile square. null means render no square at all.
// ⚠️ Broadcast (simulive) items arrive with NO mediaType, so contentType is the
// only signal; screens (collections) have neither and must stay null.
export const tileMediaIcon = (
  mediaType?: string,
  contentType?: string
): TileMediaIcon => {
  const media = (mediaType || "").toLowerCase();
  if (AUDIO_TYPES.includes(media)) return "audio";
  if (VIDEO_TYPES.includes(media)) return "video";
  if ((contentType || "").toLowerCase() === "broadcast") return "audio";
  return null;
};

// Simulive and Live Radio are live listening, not a previewable title, so they
// always show the audio icon and never the Free Preview badge, whatever the tier.
// ⚠️ Every simulive and Live Radio item on QA is tier FREE; dropping this
// exemption leaves simulive tiles with no indicator at all (MET2-2999 reopen).
const isLiveAudio = (mediaType?: string, contentType?: string) =>
  (contentType || "").toLowerCase() === "broadcast" ||
  (mediaType || "").toLowerCase() === "audio_stream";

export type TileBadge = { icon: TileMediaIcon; freePreview: boolean };

// What the top-left corner of a tile shows: the media-type square, the Free
// Preview badge, or neither. Short-form items are never "free previews".
export const tileBadge = ({
  mediaType,
  contentType,
  tier,
  previewableChapters,
  isShortForm,
}: {
  mediaType?: string;
  contentType?: string;
  tier?: string;
  previewableChapters?: boolean;
  isShortForm: boolean;
}): TileBadge => {
  const icon = tileMediaIcon(mediaType, contentType);
  if (isLiveAudio(mediaType, contentType)) return { icon, freePreview: false };
  const free = (tier || "").toLowerCase() === "free";
  const freePreview = !isShortForm && (!!previewableChapters || free);
  const showIcon = !previewableChapters && (!free || isShortForm);
  return { icon: showIcon ? icon : null, freePreview };
};
